import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { CardOptionsComponent } from '../../core/visual/card/options-card.component';

export interface MatExportDialogData {
  availableColumns: Array<any>;
  selectedColumns: Array<any>;
}

@Component({
    selector: 'app-mat-export-dialog',
    template: `
      <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
          <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
              <div fxFlex>{{title}}</div>
              <button mat-icon-button [mat-dialog-close]="false" class="button-40">
                  <mat-icon>close</mat-icon>
              </button>
          </h1>
          <mat-dialog-content class="mat-typography" fxFlex>
              <form>
                  <app-options-card title="Columns to export" [options]="availableColumns"
                                    [(checkedOptions)]="selectedColumns"></app-options-card>
              </form>
          </mat-dialog-content>
          <mat-dialog-actions align="end">
              <button mat-flat-button color="primary" (click)="closeSendConfirm('proceed')">Export</button>
          </mat-dialog-actions>
      </div>
  `,
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        CardOptionsComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class MatExportDialogComponent implements OnInit {

  title = 'Export Data';
  actionTitle = 'Export';

  availableColumns = [];
  selectedColumns = [];

  constructor(public dialogRef: MatDialogRef<MatExportDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: MatExportDialogData) {
  }

  ngOnInit() {
    if (!!this.data) {
      this.availableColumns = this.data.availableColumns || [];
      this.selectedColumns = this.data.selectedColumns || [];
    }
  }

  closeSendConfirm(action: string) {
    if (action === 'close') {
      this.dialogRef.close();
    } else {
      this.dialogRef.close(this.selectedColumns);
    }
  }
}
